<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none bg-stage-background" tabindex="0">
        <form @submit.prevent="saveVaultNote">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">Neue Sicherheitsnotiz</h1>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-6 shadow sm:rounded-sm border border-bordergray-100 overflow-hidden bg-white">
                    <loading :status="loading"/>
                    <div class="px-4 py-5 sm:p-6">
                        <div class="grid grid-cols-1 gap-6">
                            <div>
                                <label class="block text-sm font-medium leading-5 text-gray-700" for="vault-note-title">Titel</label>
                                <div class="mt-1 relative">
                                    <input
                                        id="vault-note-title"
                                        ref="titleInput"
                                        v-model.trim="form.title"
                                        class="form-input block w-full"
                                        maxlength="255"
                                        required
                                        type="text"
                                    >
                                </div>
                            </div>
                            <div>
                                <label class="block text-sm font-medium leading-5 text-gray-700" for="vault-note-description">Kurzbeschreibung (keine vertraulichen Daten)</label>
                                <div class="mt-1 relative">
                                    <textarea
                                        id="vault-note-description"
                                        v-model.trim="form.description"
                                        class="form-textarea block w-full"
                                        rows="4"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="stage-footer-surface px-4 py-3 sm:px-6 flex items-center justify-end">
                        <span class="inline-flex items-center">
                            <router-link
                                :to="vaultListPath"
                                class="btn-stage-secondary mr-4"
                            >
                                Abbrechen
                            </router-link>
                            <button class="btn-stage-primary" type="submit">
                                Notiz speichern
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
export default {
    name: "vault-new",
    metaInfo() {
        return {
            title: "Neue Sicherheitsnotiz"
        };
    },
    data() {
        return {
            loading: false,
            form: {
                title: '',
                description: '',
            },
        };
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.titleInput) {
                this.$refs.titleInput.focus();
            }
        });
    },
    computed: {
        vaultBasePath() {
            return this.$route.path.startsWith('/workspace/vault') ? '/workspace/vault' : '/vault';
        },
        apiVaultBasePath() {
            return this.$route.path.startsWith('/workspace/vault') ? 'api/workspace/vault' : 'api/vault';
        },
        vaultListPath() {
            return this.vaultBasePath === '/workspace/vault' ? '/workspace/vault' : '/vault/list';
        },
    },
    methods: {
        saveVaultNote() {
            const self = this;
            if (!this.form.title || this.form.title.trim().length < 3) {
                this.$notify({
                    title: 'Fehler',
                    text: 'Der Titel muss mindestens 3 Zeichen enthalten.',
                    type: 'error'
                });
                return;
            }
            self.loading = true;
            axios.post(self.apiVaultBasePath, {
                title: self.form.title,
                short_description: self.form.description,
            }).then(function (response) {
                const createdVaultId = response && response.data && response.data.vault
                    ? Number(response.data.vault.id || 0)
                    : 0;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: response.data && response.data.message ? response.data.message : 'Neue Notiz wurde angelegt.',
                    type: 'success'
                });
                if (createdVaultId > 0) {
                    self.$router.push(self.vaultBasePath + '/' + createdVaultId + '/manage');
                    return;
                }

                self.$router.push(self.vaultListPath);
            }).catch(function (error) {
                self.$notify({
                    title: 'Fehler',
                    text: self.getApiErrorMessage(error, 'Neue Notiz konnte nicht angelegt werden.'),
                    type: 'error'
                });
            }).finally(function () {
                self.loading = false;
            });
        },
        getApiErrorMessage(error, fallback) {
            if (error && error.response && error.response.data) {
                const responseData = error.response.data;
                if (responseData.message) {
                    return responseData.message;
                }
                if (responseData.errors && typeof responseData.errors === 'object') {
                    const firstField = Object.keys(responseData.errors)[0];
                    if (firstField && responseData.errors[firstField] && responseData.errors[firstField][0]) {
                        return responseData.errors[firstField][0];
                    }
                }
            }
            return fallback;
        }
    }
}
</script>
